<template>
  <div class="submitApplication">
    <!-- <img
      :src="
        pageData.payStatus == 1
          ? require('@/assets/images/paymentSuccess.png')
          : require('@/assets/images/paymentFailure.png')
      "
      alt=""
    /> -->
    <img src="@/assets/images/paymentSuccess.png" />
    <div class="typeTxt">
      提交成功
      <!-- {{ pageData.payStatus ? "付款成功" : "付款失败" }} -->
    </div>
    <div class="typeBtn" @click="pageJump('homeArticleManagement')">查看文章</div>
  </div>
</template>

<script>
import { reactive } from "vue";
import { useRouter } from 'vue-router';
export default {
  name: "submitApplication",
  components: {},
  setup() {
    let pageData = reactive({
      payStatus: 1,
    })

    const router = useRouter();
    function pageJump(url) {
      router.push(url);
    }
    return {
      pageData,
      pageJump
    };
  },
};
</script>
<style lang="scss" scoped>
.submitApplication {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 144px;
  }
  .typeBtn {
    width: 240px;
    height: 40px;
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    background: #008aea;
    border-radius: 8px;
    cursor: pointer;
  }
  .typeTxt {
    margin: 16px 0 24px;
    text-align: center;
    font-size: 16px;
    font-family: AlibabaPuHuiTiR;
    color: #303133;
    font-weight: 700;
  }
}
</style>
